__turbopack_context__.v({
  "answer": "Faq-module__bNQKea__answer",
  "answerContent": "Faq-module__bNQKea__answerContent",
  "container": "Faq-module__bNQKea__container",
  "faqItem": "Faq-module__bNQKea__faqItem",
  "faqList": "Faq-module__bNQKea__faqList",
  "header": "Faq-module__bNQKea__header",
  "iconWrapper": "Faq-module__bNQKea__iconWrapper",
  "open": "Faq-module__bNQKea__open",
  "questionBtn": "Faq-module__bNQKea__questionBtn",
  "section": "Faq-module__bNQKea__section",
});
